<template>
    <div class="world-map">
        <!--
        <div class="buttons_bar">
            <button @click="showWorldView()" class="world-view">World View</button>
            <button @click="showBubbleView()" class="bubble-view">Bubble View</button>
        </div>
        -->

        <div class="map_legend" v-if="mapData.type == 'map' && isMapCreated">
            <div class="legend_group first" v-if="mapHasData">
                <div class="legend_item" v-for="(item, itemKey) in legendItems">
                    <div class="item_chip" :style="{ backgroundColor: item.color}"></div>
                    <div class="item_label" v-if="(itemKey + 1) < legendItems.length">
                        {{ item.lowerBound + " - " + item.upperBound}}
                    </div>
                    <div class="item_label" v-else>
                        > {{ item.lowerBound }}
                    </div>
                </div>
            </div>
            <div class="legend_group" v-if="hasTaxHavensData" :class="(mapHasData) ? '' : 'first'">
                <div class="legend_item">
                    <div class="item_chip" data-bg="orange"></div>
                    <div class="item_label">Tax havens</div>
                </div>
            </div>
            <div class="legend_group" :class="(hasTaxHavensData) ? 'last' : ''">
                <div class="legend_item">
                    <div class="item_chip" data-bg="white"></div>
                    <div class="item_label">No data</div>
                </div>
            </div>
        </div>

        <div class="map_legend" v-else-if="mapData.type == 'bubbles' && isMapCreated">
            <div class="legend_group first">
                <div class="legend_item">
                    <div class="item_chip" data-bg="orange"></div>
                    <div class="item_label">Tax havens</div>
                </div>
            </div>
            <div class="legend_group" v-if="hasTaxHavensData">
                <div class="legend_item">
                    <div class="item_chip" data-bg="light"></div>
                    <div class="item_label">Non-tax havens</div>
                </div>
            </div>
        </div>

        <div class="svg_container" :style="{width: fitWidth + 'px', height: fitHeight + 'px' }">
            <div class="loader lds-ellipsis" :class="(loaderDisplayed) ? 'displayed' : ''"><div></div><div></div><div></div><div></div></div>
            <svg ref="svg" preserveAspectRatio="xMinYMin meet" :viewBox="'0 0 '+fitWidth+' '+fitHeight"></svg>
            <div ref="tooltip" class="tooltip" style="position: absolute; display: none; pointer-events: none;" :data-clickable="isTooltipClickable">
                <p ref="tooltipCountry" class="tooltip_country"></p>
                <p class="tooltip_value">
                    <span ref="tooltipValueChip" class="tooltip_value_chip"></span>
                    <span ref="tooltipValueNumber" class="tooltip_value_number"></span>
                </p>
                <p class="tooltip_click">Click to learn more</p>
            </div>
        </div>

        <div class="app_timeline map_timeline" :data-isplaying="isPlaying" v-if="hasTimeline">
            <button class="timeline_bt" @click="togglePlay"></button>
            <div class="timeline_year">{{currentYear}}</div>
            <v-slider class="timeline_slider" v-model="currentYear" :min="minYear" :max="maxYear" @start="dragStart" @end="dragEnd"></v-slider>
        </div>
    </div>
</template>

<script>
    import * as d3 from "d3";
    import Vue from 'vue'
    //import { geoRobinson } from "d3-geo-projection";
    import { feature } from 'topojson-client'
    import { interpolate, circlePath } from 'flubber'

    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import Vuetify from 'vuetify'
    Vue.use(Vuetify)
    import 'vuetify/dist/vuetify.min.css'

    export default {

        components: {
        },

        props: {
            mapData: {
                type: Object,
                default: function (){
                    return {
                        type: "map", countries: []
                    };
                }
            },

            indicatorUnit: {
                type: String,
                default: function (){
                    return ""
                }
            },

            indicatorID: {
                type: String,
                default: function (){
                    return ""
                }
            },

            hasTaxHavensData: {
                type: Boolean,
                default: function (){
                    return false
                }
            },

            hasTimeline: {
                type: Boolean,
                default: function () {
                    return true
                }
            }
        },
        data() {
            return {
                isGeojsonLoaded: false,
                isMapCreated: false,
                loaderDisplayed: true,
                width: 1280,
                height: 590,
                fitWidth: 1280,
                fitHeight: 590,
                responsiveMinWidth: 1024,
                mapMinWidth: 440,
                geojson: null,
                projection: null,
                path: null,
                colorScale: {},
                geojsonCountryKey: "ISO3",
                minBubbleRadius: 5,
                maxBubbleRadius: 40,

                availableYears: [],
                currentYear: null,
                minYear: 2000,
                maxYear: 2030,
                isPlaying: false,
                timerId: null,
                mapHasData: true,

                maxYearValue: 0,
                maxAllValues: 0,
                legendItems: [],
                modalTooltipValueNumber: "",
                modalTooltipColor: "",
                isTooltipClickable: true,
            }
        },

        mounted() {
            var self = this;
            let geoRobinson;

            this.mapMinWidth = document.body.scrollWidth;

            import("d3-geo-projection").then((module) => {
                geoRobinson = module.geoRobinson;

                var $container = document.querySelector(".world-map");
                var containerWidth =$container.offsetWidth;

                self.fitWidth = self.width;
                self.fitHeight = self.height;
                if(containerWidth < self.width){
                    self.fitWidth = containerWidth;
                    if(self.fitWidth < self.responsiveMinWidth){
                        self.fitWidth = self.mapMinWidth;
                        self.fitHeight = ((self.fitWidth * self.height) / self.width) + 100;
                    } else {
                        self.fitHeight = ((self.fitWidth * self.height) / self.width);
                    }
                    
                }

                if(self.fitWidth < 600){
                    self.minBubbleRadius = 3;
                    self.maxBubbleRadius = 25;
                }
                
                self.projection = geoRobinson().fitSize([self.fitWidth, self.fitHeight], {
                    type: 'Sphere'
                })
                

                // Define the Robinson projection
                /*
                self.projection = geoRobinson()
                    .scale(148)
                    .translate([self.width / 2, self.height / 2])
                    .precision(.1);
                */

                self.loadData();
            });
        },

        methods:{
            async loadData(){
                var self = this;
                
                await self.fetchMapData()
                //await self.fetchData()

                if(this.mapData.countries != undefined && this.mapData.countries.length > 0){
                    //await self.fetchData()
                    self.renderMap();
                }
            },

            async fetchMapData() {
                var myCacheBuster = new Date().getTime()

                /*
                const world = await d3.json(
                    'https://batcave.wedodata.fr/bubble-map/data/countries-110m.json?t='+myCacheBuster
                    )
                */

                
                //const world2 = await d3.json('/geojson/world-highres2.geo.json?t='+myCacheBuster)
                const world2 = await d3.json('/geojson/new_clem_world_countries_data.geo.json?t='+myCacheBuster)
                //const world2 = await d3.json('/geojson/updated_new_clem_world_countries_data.geo.json?t='+myCacheBuster);
                //const world2 = await d3.json('http://localhost:8888/pse-tax/static/geojson/geojson-natural-earth.json');
                //this.geojson = feature(world, world.objects.countries).features.filter( (d) => d.id !== '010')

                var mapCountries = _.map(world2.features, function (o){
                    return o.properties.ISO3;
                })

                this.geojson2 = world2.features;
                this.isGeojsonLoaded = true;
            },

            /*
            async fetchData() {
                const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTuP1qPq-pSRZ5ygHmt_BdEOSi0cIderB5adhocU4cdKnH8WrI1QH894_b_6NWmnEUTMyZEaEL1ta7v/pub?gid=0&single=true&output=csv'
                const cacheBuster = new Date().getTime()
                const data = await d3.csv(`${csvUrl}&t=${cacheBuster}`)
                this.dataById = new Map(data.map((d) => [d['country-name'], +d['country-value']]))
            },
            */

            renderMap() {
                var self = this;

                const svg = d3.select(this.$refs.svg)
                const tooltip = d3.select(this.$refs.tooltip)
                const tooltipCountry = d3.select(this.$refs.tooltipCountry)
                const tooltipValueChip = d3.select(this.$refs.tooltipValueChip)
                const tooltipValueNumber = d3.select(this.$refs.tooltipValueNumber)
                this.path = d3.geoPath().projection(this.projection)

                this.updateMapData();

                // Create paths for countries that haven't been added yet
                var filteredCountries = this.geojson2.filter((d) => d.properties[self.geojsonCountryKey] !== 'ATA');

                const countries = svg.selectAll('.country')
                .data(filteredCountries)

                countries.enter()
                .append('path')
                .attr('class', 'country')
                .attr('data-country', function (d){
                    return d.properties[self.geojsonCountryKey];
                })
                .attr('data-transition', 0)
                .attr('d', function (d) {
                    const pathD = self.path(d);
                    return pathD;
                })
                .attr('transform', (d) => `translate(0,0)`)
                .attr("stroke", "#164193")
                .attr("stroke-width", 0.5)
                .attr("data-taxhaven", (d) => {
                    const value = self.dataById.get(d.properties[self.geojsonCountryKey])
                    if(self.mapData.type == "bubbles") {
                        if(value == undefined) return "false";
                        else return "true"; 
                    } else {
                        if(value == 'taxhaven') return "true";
                        return "false";
                    }
                })
                .attr('fill', (d) => {
                    const value = self.dataById.get(d.properties[self.geojsonCountryKey])
                    if(self.mapData.type == "bubbles") {
                        if(value == undefined) return "#BAC6DF";
                        else return "#F18321"; 
                    }
                    else {
                        if(value == 'taxhaven') return "#F18321"
                        if(value == 0) return "#C2DDF5";
                        return value ? self.colorScale(value) : '#fff'
                    }
                })
                .on('mouseover', () => tooltip.style('display', null))
                .on('mouseout', () => tooltip.style('display', 'none'))
                .on('click touchstart', (d) => {
                    var isClickable = true;
                    const value = self.dataById.get(d.properties[self.geojsonCountryKey])
                    if(self.mapData.type == "bubbles") {
                        if(value == undefined) isClickable = false;
                    } else {
                        if(value == 'taxhaven') isClickable = false;
                    }

                    if(isClickable){
                        var countryObj = UTILS.DB_COUNTRIES_OBJ[d.properties[self.geojsonCountryKey]];
                        self.$emit('countryClicked', countryObj.iso3, self.modalTooltipValueNumber, self.modalTooltipColor);
                    }
                    
                })
                .on('mousemove', (d) => {
                    var [x, y] = d3.mouse(svg.node())

                    var $svgContainer = document.querySelector("#Wrapper_map .svg_container");
                    var bbox = $svgContainer.getBoundingClientRect();
                    if(x + 300 > (bbox.width)){
                        x = x - 230;
                    }

                    self.isTooltipClickable = true;
                    const value = self.dataById.get(d.properties[self.geojsonCountryKey])
                    if(self.mapData.type == "bubbles") {
                        if(value == undefined) self.isTooltipClickable = false;
                    } else {
                        if(value == 'taxhaven') self.isTooltipClickable = false;
                    }

                    tooltip
                        .style('left', `${x + 15}px`)
                        .style('top', `${y}px`)
                    tooltipCountry.text(`${UTILS.DB_COUNTRIES_OBJ[d.properties[self.geojsonCountryKey]].country_name}`);

                    var hexaColor = "#fff";

                    if(self.mapData.type == "bubbles") {
                        if(value == undefined || isNaN(value)) hexaColor = "#BAC6DF";
                        else hexaColor = "#F18321"; 
                    }
                    else {
                        if(value == 'taxhaven') hexaColor = "#F18321"
                        else if(value != undefined && !isNaN(value)) hexaColor = self.colorScale(value)
                        else hexaColor = '#fff';
                    }

                    document.querySelector(".tooltip_value_chip").style.backgroundColor = hexaColor;

                    if(value == 'taxhaven'){
                        tooltipValueNumber.text("Tax haven country");
                        self.modalTooltipValueNumber = "Tax haven country";
                    } else if(value == undefined || isNaN(value)){
                        tooltipValueNumber.text("No data");
                        self.modalTooltipValueNumber = "No data";
                    } else {
                        var formattedValue = "";
                        if(self.indicatorUnit == "%") {
                            formattedValue = UTILS.formatNumber(self.dataById.get(d.properties[self.geojsonCountryKey]), 2, self.indicatorUnit);
                        } else{
                            formattedValue = UTILS.formatNumber(self.dataById.get(d.properties[self.geojsonCountryKey]), 2);
                        }
                        tooltipValueNumber.text(`${formattedValue}` + `${self.indicatorUnit}`);
                        self.modalTooltipValueNumber = `${formattedValue}` + `${self.indicatorUnit}`;
                    }

                    self.modalTooltipColor = hexaColor;
                })

                setTimeout(function (){
                    self.isMapCreated = true;
                    self.loaderDisplayed = false;
                })
            },

            updateMapData: function () {
                var self = this;
                var dataCountries = [];

                if(this.mapData.type == "map"){
                    dataCountries = _.filter(this.mapData.countries, function (o){ return o.isTaxHaven == undefined || !o.isTaxHaven; });
                } else {
                    dataCountries = _.filter(this.mapData.countries, function (o){ return o; });
                }

                if(dataCountries.length > 0){
                    this.mapHasData = true;
                    this.availableYears = _.keys(dataCountries[0].years);
                    //if(this.currentYear == null || dataCountries[0].years[this.currentYear] == undefined)
                    this.currentYear = parseInt(this.availableYears[this.availableYears.length - 1], 10);
                    this.maxYear = parseInt(this.availableYears[this.availableYears.length - 1], 10);
                    this.minYear = parseInt(this.availableYears[0], 10);
                } else {
                    this.mapHasData = false;
                }

                if(this.isMapCreated){
                    this.updateMapYear();
                } else {
                    this.updateMapLegend(dataCountries);
                    this.dataById = new Map(this.mapData.countries.map((d) => {
                        if(d['years'] == undefined) return [d['countryCode'], 'taxhaven']
                        else if(d['years'][self.currentYear] == undefined || d['years'][self.currentYear] == "nodata") return [d['countryCode'], 0]
                        return [d['countryCode'], +d['years'][self.currentYear]['value']]
                    }))
                }
                this.$emit('currentYear', this.currentYear);
            },

            updateMapLegend: function (dataCountries){
                var self = this;
                var allYearsValues = [];
                _.each(dataCountries, function(o){
                    _.each(o.years, function (yObj){
                        if(yObj.value != null && yObj.value != '' && yObj.value != 'nodata') allYearsValues.push(yObj.value);
                    })
                })

                const sortedData = allYearsValues.sort((a, b) => a - b);
                if(sortedData.length > 0){
                    this.mapHasData = true;
                    var minValue = sortedData[0];
                    this.maxAllValues = sortedData[sortedData.length-1];
                    const l = allYearsValues.length;

                    var thresholds = [
                      sortedData[Math.round(l * 0.2) - 1],
                      sortedData[Math.round(l * 0.4) - 1],
                      sortedData[Math.round(l * 0.6) - 1],
                      sortedData[Math.round(l * 0.8) - 1]
                    ];


                    if(this.indicatorID == "corp_tax_lost"){
                        thresholds = [4,8,12,16];
                    } else if(this.indicatorID == "pctGDPFinancial"){
                        thresholds = [3,6,11,20];
                    } else if(this.indicatorID == "pctGDP"){
                        thresholds = [0.2,0.4,0.8,3]
                    } else if(this.indicatorID == "Capital_tax_rate"){
                        thresholds = [7,11,18,27]
                    } else if(this.indicatorID == "Corporate_tax_rate"){
                        thresholds = [8,14,19,28]
                    } else if(this.indicatorID == "Labor_tax_rate"){
                        thresholds = [2,5,10,25]
                    } else if(this.indicatorID == "Total_tax_NDP"){
                        thresholds = [11,16,23,36]
                    }
                    
                    this.colorScale = d3.scaleThreshold().domain(thresholds).range(["#C2DDF5","#99BBE3","#7390CD","#3167B4","#1F4C8C"]);

                    /*
                    //Quantile Scalle
                    this.maxYearValue = UTILS.computeYearMaxValue(dataCountries, this.currentYear);
                    console.log("maxYearValue", this.maxYearValue);
                    
                    this.colorScale = d3.scaleQuantize()
                        .domain([0, this.maxYearValue])
                        .range(["#C2DDF5","#99BBE3","#7390CD","#3167B4","#1F4C8C"]);
                    */

                    this.legendItems = [];
                    var tmpLegendItems = [];

                    this.colorScale.range().forEach(function(color) {
                        let d = self.colorScale.invertExtent(color);
                        if(d[0] == undefined || d[0] == null) d[0] = 0;
                        if(d[1] == undefined || d[1] == null) d[1] = self.maxAllValues;

                        let lowerBound = 0;
                        let upperBound = 100000;

                        if(self.indicatorUnit == "%" || self.indicatorID == "Aggregate (in USD billions)"){
                            lowerBound = d[0];
                            upperBound = d[1];
                        } else if(self.indicatorUnit == " B$" || self.indicatorUnit == " M$"){
                            lowerBound = Math.round(d[0]);
                            upperBound = Math.round(d[1]);
                        } else {
                            lowerBound = Math.round(d[0]/1000) * 1000; // round to nearest 1000
                            upperBound = Math.round(d[1]/1000) * 1000; // round to nearest 1000
                        }

                        tmpLegendItems.push({
                            lowerBound: UTILS.formatNumber(lowerBound, 2),
                            upperBound: UTILS.formatNumber(upperBound, 2),
                            color: color
                        });
                    });

                    this.legendItems = JSON.parse(JSON.stringify(tmpLegendItems));
                } else {
                    this.mapHasData = false;
                }
            },

            updateMapYear: function (){
                var self = this;
                var dataCountries = [];

                if(this.mapData.type == "map"){
                    dataCountries = _.filter(this.mapData.countries, function (o){ return o.isTaxHaven == undefined || !o.isTaxHaven; });
                } else {
                    dataCountries = _.filter(this.mapData.countries, function (o){ return o; });
                }
                this.updateMapLegend(dataCountries);

                this.dataById = new Map(this.mapData.countries.map((d) => {
                    //console.log("d", d, d['years'][self.currentYear]);
                    if(d['years'] == undefined) return [d['countryCode'], 'taxhaven']
                    else if(d['years'][self.currentYear] == undefined || d['years'][self.currentYear] == "nodata") return [d['countryCode'], 0]
                    return [d['countryCode'], +d['years'][self.currentYear]['value']]
                }))

                const svg = d3.select(this.$refs.svg)

                let countries = svg.selectAll("path.country")
                .attr("fill", d => {
                    const value = self.dataById.get(d.properties[self.geojsonCountryKey])
                    if(self.mapData.type == "bubbles") { 
                        if(value == undefined || isNaN(value)) return "#BAC6DF";
                        return "#F18321"; 
                    }
                    else {
                        if(value == 'taxhaven') return "#F18321"
                        return value ? self.colorScale(value) : '#fff'
                    }
                })
                .attr("data-taxhaven", (d) => {
                    const value = self.dataById.get(d.properties[self.geojsonCountryKey])
                    if(self.mapData.type == "bubbles") {
                        if(value == undefined) return "false";
                        else return "true"; 
                    } else {
                        if(value == 'taxhaven') return "true";
                        return "false";
                    }
                })


                if(this.mapData.type == "bubbles"){
                    this.showBubbleView();
                } else {
                    this.showWorldView();
                }

                this.$emit('currentYear', this.currentYear);
            },

            showWorldView() {
                var self = this;
                
                d3.selectAll(".bubble_text").remove();
                const svg = d3.select(this.$refs.svg)
                // Select the existing paths
                const shapes = svg.selectAll('[data-transition="1"]') // Only select shapes that have completed the transition to circles

                shapes
                .transition()
                .duration(1000)
                .attrTween('d', function(d, i) {
                  const currentPath = d3.select(shapes.nodes()[i]).attr('d')
                  var targetPath = self.path(d)

                  const complexPathString = self.path(d)
                  const subpaths = self.splitPathBySubpaths(complexPathString);

                    let maxArea = -1;
                    let largestSubpath2 = '';
                    
                    subpaths.forEach(subpath => {
                        const boundingBox = self.getBoundingBox(subpath);
                        const area = boundingBox.width * boundingBox.height;

                        if (area > maxArea) {
                            maxArea = area;
                            largestSubpath2 = subpath;
                        }
                    });

                    const rest = subpaths.filter(subpath => subpath !== largestSubpath2);
                    targetPath = largestSubpath2 + rest.join('');
                    /*
                    const largestSubpath = subpaths.reduce((largestPath, currentPath) => {
                      return self.calculatePathArea(currentPath, d.properties.ISO2) > self.calculatePathArea(largestPath, d.properties.ISO2)
                        ? currentPath
                        : largestPath;
                    });
                    if(d.properties.ISO2 == "FR") console.log("largestSubpath", largestSubpath);
                    */
                  const interpolator = interpolate(currentPath, targetPath)

                  return (t) => {
                    d3.select(shapes.nodes()[i]).attr('data-transition', '0')
                    return interpolator(t)
                  }
                })
                .on('end', function(d,i) {
                  shapes.attr('transform', null) // Remove the transform attribute
                })
            },

            showBubbleView() {
                d3.selectAll(".bubble_text").remove();
                this.renderBubbleMap()
            },

            renderBubbleMap() {
                var self = this;

                const svg = d3.select(this.$refs.svg)
                const tooltip = d3.select(this.$refs.tooltip)
                const tooltipText = d3.select(this.$refs.tooltipText)
                const colorScale = d3.scaleSequential()
                .domain([1, 100])
                .interpolator(d3.interpolateBlues)

                // Select the existing paths
                const shapes = svg.selectAll('.country')

                // Animate the transition to circles
                  shapes
                    .transition()
                    .duration(1000)
                    .attrTween('d', function(d, i) {
                      const complexPathString = d3.select(shapes.nodes()[i]).attr('d')
                      const subpaths = self.splitPathBySubpaths(complexPathString);
                      
                        let maxArea = -1;
                        let largestSubpath2 = '';
                        
                        subpaths.forEach(subpath => {
                            const boundingBox = self.getBoundingBox(subpath);
                            const area = boundingBox.width * boundingBox.height;

                            if (area > maxArea) {
                                maxArea = area;
                                largestSubpath2 = subpath;
                            }
                        });

                      var value = self.dataById.get(d.properties[self.geojsonCountryKey]) || 1
                      if(isNaN(value)) value = 1;
                      const circlePath = self.myCirclePath(d, value)
                      const interpolator = interpolate(largestSubpath2, circlePath)

                      return (t) => {
                        d3.select(shapes.nodes()[i]).attr('data-transition', '1')
                        return interpolator(t)
                      }
                    })
                    .on('end', () => {
                        
                    })

                    
                    setTimeout(function (){
                        self.afterPathToBubbleAnimation();
                    }, 1000)
            },

            splitPathBySubpaths:function(pathString) {
              const commands = pathString.split(/(?=[Mm])/);
              return commands.map((cmd) => cmd.trim());
            },

            getBoundingBox: function (subpath){
                const commands = subpath.split(/(?=[ML])/);
                let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;

                commands.forEach(command => {
                    const parts = command.split(',').map(str => parseFloat(str.match(/-?\d+(\.\d+)?/g)));
                    if (parts.length >= 2) {
                        let x = parts[parts.length - 2];
                        let y = parts[parts.length - 1];
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                    }
                });

                return {
                    width: maxX - minX,
                    height: maxY - minY
                };
            },

            calculatePathArea:function(pathString, countryCode) {
              const points = pathString.match(/[MLZmlz]\s*([\d.,\s]+)|\s*[\d.,\s]+/g);
              const regex = /-?[\d.]+/g;

              let x = 0,
                y = 0,
                area = 0,
                match;

              for (let i = 0, len = points.length; i < len; i++) {
                const point = points[i];
                if (point[0].toUpperCase() === "Z") {
                  break;
                }

                match = point.match(regex);
                if (match) {
                  let newX = parseFloat(match[0]);
                  let newY = parseFloat(match[1]);
                  area += (x + newX) * (y - newY);
                  x = newX;
                  y = newY;
                }
              }

              return Math.abs(area / 2);
            },

            afterPathToBubbleAnimation: function (){
                var self = this;

                // Select the existing paths
                const svg = d3.select(this.$refs.svg)
                const shapes = svg.selectAll('.country')

                svg.selectAll("text").remove();

                const top5 = shapes.data().sort((a, b) => {
                    return self.circleRadius(self.dataById.get(b.properties[self.geojsonCountryKey])) - self.circleRadius(self.dataById.get(a.properties[self.geojsonCountryKey]));
                }).slice(0, 5);

                const simulation = d3.forceSimulation(shapes.data())
                .force('x', d3.forceX((d) => self.path.centroid(d)[0]).strength(0.5))
                .force('y', d3.forceY((d) => self.path.centroid(d)[1]).strength(0.5))
                .force("collide", d3.forceCollide(10).radius(function(d){ 
                    return self.circleRadius(self.dataById.get(d.properties[self.geojsonCountryKey])) 
                }))
                .stop();
                // ... (remaining force simulation setup)

                for (var i = 0; i < 1000; ++i) simulation.tick();

                shapes
                .transition().attr('transform', function(d) { 
                    var centroid = self.path.centroid(d)
                    return 'translate(' +Math.round(d.x - centroid[0])+ ',' +Math.round(d.y -  centroid[1]) + ')'
                });

                shapes.each(function(d) {
                    if (top5.includes(d)) {
                        const text = svg.append("text")
                            .attr("x", d.x)
                            .attr("y", d.y)
                            .attr("text-anchor", "middle")
                            .attr("dominant-baseline", "central")
                            .attr("class", "bubble_text")
                            .text(function() { return UTILS.DB_COUNTRIES_OBJ[d.properties[self.geojsonCountryKey]].country_name}); // replace with the desired label
                    }
                });
            },

            myCirclePath(feature) {
                var value = this.dataById.get(feature.properties[this.geojsonCountryKey])
                if(isNaN(value)) value = 0;

                // Calculate the centroid of the feature's polygon
                const centroid = this.projection(d3.geoCentroid(feature))
                const x = centroid[0]
                const y = centroid[1]

                // Calculate the radius based on the value and scaleFactor
                var radius = this.circleRadius(value);
                // Generate the circle path
                const circle = d3.path()
                circle.arc(x, y, radius, 0, 2 * Math.PI)

                return circle.toString()
            },

            circleRadius(value) {
                var self = this;
                if(isNaN(value) || value == undefined) value = 0;
                const minRadius = self.minBubbleRadius
                const maxRadius = self.maxBubbleRadius

                const scale = d3.scaleLinear().domain([0, self.maxAllValues]).range([minRadius, maxRadius])

                var scaleRadius = 0;
                if(value != undefined) scaleRadius = scale(value)
                else scaleRadius = minRadius;

                return scaleRadius;
            },

            togglePlay() {
                this.isPlaying = !this.isPlaying;

                if (this.isPlaying) {
                    this.startTimer();
                } else {
                    this.stopTimer();
                }
            },
            startTimer() {
                if(this.currentYear >= this.maxYear){
                    this.currentYear = this.minYear;
                }

                var timing = 1000;
                if(this.mapData.type == "bubbles") timing = 3000;

                this.timerId = setInterval(() => {
                    if (this.currentYear < this.maxYear) {
                      this.currentYear++;
                    } else {
                      this.stopTimer();
                    }
                }, timing);
            },

            stopTimer() {
                clearInterval(this.timerId);
                this.timerId = null;
                this.isPlaying = false;
            },

            dragStart(){
                this.stopTimer();
            },

            dragEnd() {
                this.stopTimer();
            },

            tryRenderMap: function (){
                var self = this;
                if(this.isGeojsonLoaded){
                    if(this.mapData.countries.length > 0){
                        this.renderMap();
                    }
                } else {
                    setTimeout(function (){
                        self.tryRenderMap();
                    }, 1000)
                }
            }
        },

        watch: {
            mapData: function (){
                var self = this;
                if(this.isGeojsonLoaded){
                    if(this.mapData.countries.length > 0){
                        if(this.isMapCreated) this.updateMapData();
                        else this.renderMap();
                    } else {
                        this.updateMapData();
                    }
                } else {
                    setTimeout(function (){
                        self.tryRenderMap();
                    }, 1000)
                }
            },

            currentYear: function () {
                var self = this;
                if(this.isGeojsonLoaded){
                    if(this.isMapCreated) this.updateMapYear();
                }
            }
        }
    }
</script>

<style lang="scss">
     @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    .world-map {
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-align: center;
        .map_timeline{
            margin: 0 180px;
            background: #fff;
        }
        .svg_container{
            display: inline-block;
            vertical-align: top;
            position: relative;
            svg{
                width: 100%;
                height: 100%;
                .country{
                    transition: transform 0.6s ease-in-out;
                    cursor: pointer;
                    &:hover{
                        fill-opacity:.6;
                    }
                }
                text{
                    color: $colorBlack;
                    font-size: 12px;
                    fill: $colorBlack;
                    font-family: 'Roboto', sans-serif;
                    font-weight: 500;
                    &.bubble_text{
                        pointer-events: none;
                    }
                    
                }
            }
        }
    }

    .tooltip {
        background: #fff;
        padding: 16px 20px 0px 20px;
        border-radius: 4px;
        text-align: left;
        min-width: 200px;
        box-shadow: 0px 0px 1.7517952919006348px 0px rgba(40, 24, 88, 0.08), 0px 0px 4.430421829223633px 0px rgba(40, 24, 88, 0.11), 0px 0px 9.037644386291504px 0px rgba(40, 24, 88, 0.14), 0px 0px 18.6158390045166px 0px rgba(40, 24, 88, 0.18), 0px 0px 51px 0px rgba(40, 24, 88, 0.31);
        .tooltip_country{
            font-size: 14px;
            color: $colorBlack;
            margin: 0;
            border-bottom: 1px solid #BAC6DF;
            padding-bottom: 10px;
            margin-bottom: 10px;
        }
        .tooltip_value{
            font-size: 16px;
            line-height: 20px;
            font-weight: 700;
            color: $colorBlack;
            margin: 0;
            white-space: nowrap;
            padding-bottom: 10px;
            border-bottom: 1px solid #BAC6DF;
            .tooltip_value_chip, .tooltip_value_number{
                display: inline-block;
                vertical-align: middle;
            }
            .tooltip_value_chip{
                width: 14px;
                height: 14px;
                border-radius: 2px;
                margin-right: 4px;
                border: 1px solid $colorBlack;
            }
        }
        &[data-clickable="true"]{
            .tooltip_click{
                display: block;
            }
        }
        .tooltip_click{
            font-size: 12px;
            font-style: italic;
            position: relative;
            color: #2E5BB0;
            margin-top: 10px;
            font-weight: 500;
            padding-left: 15px;
            line-height: 16px;
            height: 16px;
            display: none;
            &:before{
                content: "";
                position: absolute;
                left: 0px;
                top: 50%;
                transform: translate(0, -50%);
                background: url("/images/cursor.svg") no-repeat 0 0;
                background-size: 100% 100%;
                width: 11px;
                height: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// components/mapChoropleth.vue